import { Box, styled, Typography } from "@material-ui/core";
import {
  EPOCUS_BORDER,
  EPOCUS_SELECTED_BG,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../_lib/epocus-palette";

export const SettingsCard = styled(Box)({
  backgroundColor: EPOCUS_WHITE,
  borderRadius: 12,
  padding: 16,
  border: `1px solid ${EPOCUS_BORDER}`,
  display: "flex",
  flexDirection: "column",
  gap: 12,
});

export const SettingsCardLabel = styled(Typography)({
  fontSize: rem(12),
  fontWeight: 700,
  letterSpacing: "0.08em",
  color: EPOCUS_TEXT_SECONDARY,
  textTransform: "uppercase",
});

export const SettingsCardLabelRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
});

const GroupHeadingRow = styled(Box)({
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between",
  gap: 10,
  marginTop: 8,
});

const GroupTitle = styled("h2")({
  margin: 0,
  fontSize: rem(15),
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
});

const GroupScope = styled(Typography)({
  fontSize: rem(11),
  color: EPOCUS_TEXT_SECONDARY,
});

export const SettingsGroupHeading: FCwC<{ scope?: string }> = ({
  children,
  scope,
}) => (
  <GroupHeadingRow>
    <GroupTitle>{children}</GroupTitle>
    {scope && <GroupScope>{scope}</GroupScope>}
  </GroupHeadingRow>
);

export const SettingsScopeChip = styled("span")({
  display: "inline-flex",
  alignItems: "center",
  backgroundColor: EPOCUS_SELECTED_BG,
  color: EPOCUS_TEXT_SECONDARY,
  fontSize: rem(10),
  fontWeight: 700,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  padding: "3px 8px",
  borderRadius: 999,
  whiteSpace: "nowrap",
});
